import React, { useState, useEffect } from 'react';
import { Box, Typography, Table, TableContainer, TableHead, TableRow, TableCell, TableBody, Paper } from '@mui/material';
import Rating from '@mui/material/Rating';
import { supabase } from '../../supabaseClient';

const FeedbackTable = ({ companyId }) => {
  const [feedback, setFeedback] = useState([]);

  const fetchFeedback = async () => {
    let query = supabase.from('feedback').select('*,sessions (*)');
    
    if (companyId) {
      query = query.eq('company_id', companyId);
    }

    const { data, error } = await query;

    if (error) {
      console.error('Error fetching feedback:', error);
      return;
    }

    setFeedback(data);
  };

  useEffect(() => {
    fetchFeedback();
  }, [companyId]);

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Fecha</TableCell>
            <TableCell>Comentario</TableCell>
            <TableCell>Calificación</TableCell>
            <TableCell>Nombre del Usuario</TableCell>
            <TableCell>Apellido del Usuario</TableCell>
            <TableCell>Género del Usuario</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {feedback.map((item) => (
            (item.rating !== 0 || item.feedback.trim() !== '') && (
              <TableRow key={item.id}>
                <TableCell>{item.sessions.created_at.substring(0, 9)}</TableCell>
                <TableCell>{item.feedback.trim() !== '' ? item.feedback : 'N/A'}</TableCell>
                <TableCell>
                  <Rating value={item.rating} readOnly />
                </TableCell>
                <TableCell>{item.user_first_name}</TableCell>
                <TableCell>{item.user_last_name}</TableCell>
                <TableCell>{item.user_gender}</TableCell>
              </TableRow>
            )
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default FeedbackTable;
